import { render, staticRenderFns } from "./BmvTable.vue?vue&type=template&id=28cb7eed&scoped=true"
import script from "./BmvTable.vue?vue&type=script&lang=js"
export * from "./BmvTable.vue?vue&type=script&lang=js"
import style0 from "./BmvTable.vue?vue&type=style&index=0&id=28cb7eed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb7eed",
  null
  
)

export default component.exports